export enum IotAction {
  OPEN = 'open',
  ADD = 'add',
  CREATE = 'create',
  EDIT = 'edit',
  RENEW = 'renew',
  DELETE = 'delete',
  CONFIGURE = 'configure',
  EXPORT = 'export',
  CLOSE = 'close'
}
